import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import Menu from "../../components/Menu/Menu";
import { MenuProps } from "../../components/Menu/MenuTypes";
import { defaultMenuProps } from "../../constants/constants";
import ServiceData from "../../components/Service/ServiceData/ServiceData";
import { ServiceDataProps } from "../../components/Service/ServiceData/ServiceDataTypes";
import { getApiService } from "../../services/apiService";

const EditarServicio = (): React.ReactElement => {
  const urlParams = useParams();
  const [menuProps] = useState<MenuProps>(defaultMenuProps);
  const [serviceData, setServiceData] = useState<ServiceDataProps>({ service: { _id: '' } });
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    getApiService({ _id: urlParams.servicioId })
      .then((response: any) => {
        setServiceData({ service: response });
        setLoaded(true);
      })
      .catch((error: any) => {
        console.log(error.message);
      });
  }, []);

  return (
    <React.Fragment>
      <div id="menu">
        <Menu items={menuProps.items} />
      </div>
      <div id="app-content">
        <header className="table-header mb-4">
          <h1>Editar servicio</h1>
          <span></span>
        </header>
        {loaded && <ServiceData service={serviceData.service} />}
      </div>
    </React.Fragment>
  );
};

export default EditarServicio;
